// extracted by mini-css-extract-plugin
export default {"container":"Controls_container__aiFkw","lobby":"Controls_lobby__3lrD-"};